<template>
  <section id="company_container" class="custom-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <AssingPermisses ref="refAssingPermisses" @updatedDevice="updatedDevice"/>
    <div class="columns v-align-center">
      <div class="column is-3">
        <CompanySelector v-model="company"/>
      </div>
      <div class="column input-search-content mt-button2">
        <b-field class="input-search">
          <b-input
              placeholder="Buscar"
              type="text"
              name="search"
              v-model="search"
              icon-right="magnify"
              icon-right-clickable
              @icon-right-click="editModal = true"
          >
          </b-input>
        </b-field>
        <b-field class="pagination-select">
          <b-select
              placeholder="Páginas"
              expanded
              v-model="pagination"
              name="pagination"
          >
            <option
                v-for="option in paginationList"
                :value="option.id"
                :key="option.id"
                :id="option.id"
            >
              {{ option.label }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column text-right mt-button2">
        <vs-button
            color="primary"
            icon="add"
            class="btn-add-device"
            @click="openModal"
        >Asignar Permisos
        </vs-button
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData">
          <b-table-column field="code" label="Id" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.code }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="company.code" label="Empresa" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.company.name }}
            </text-highlight>
          </b-table-column>
          <b-table-column
              field="id"
              label="Cantidad de usuarios"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ props.row.id }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="id" label="Cantidad de módulos" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.id }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="status" label="Estado" v-slot="props">
            <text-highlight :queries="search">
              {{ parseStatus(props.row.status) }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="title" label="Nombre terminal" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                <text-highlight :queries="search">
                  {{ props.row.title }}
                </text-highlight>
              </span>
              <div class="options flex">
                <button
                    title="Gestionar permisos"
                    class="btn primary edit"
                    v-on:click="editRow(props.row)"
                >
                  <span class="material-icons"> settings </span>
                </button>
              </div>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-if="checkPages()">
        <vs-pagination
            :max="5"
            :total="totalPages"
            v-model="page"
            prev-icon="arrow_back"
            next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import {DETAILS_STATUS} from "@/global/constants";
import {configToast, TOAST_TYPES} from "@/global/toast";
import AssingPermisses from "./AssingPermisses.vue";
import CompanySelector from "@/components/Shared/CompanySelector";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";

export default {
  components: {AssingPermisses, CompanySelector},
  data: () => ({
    isLoading: false,
    selected: null,
    tableData: [],
    originalData: [],
    search: "",
    pagination: 10,
    totalPages: 0,
    paginationList: [
      {id: 10, label: "10"},
      {id: 30, label: "30"},
      {id: 60, label: "60"},
      {id: 100, label: "100"},
      {id: 1000, label: "1000"},
    ],
    forRemove: null,
    page: 1,
    company: null,
  }),
  watch: {
    search: function (value) {
      this.tableData = this.originalData.filter((item) => {
        const string = JSON.stringify(item) + this.parseStatus(item.status);
        return new RegExp(`${value}`, "igm").test(string);
      });
    },
    page: function () {
      this.splitData();
    },
    company() {
      this.getListDevices();
    }
  },

  methods: {
    parseStatus(status) {
      return DETAILS_STATUS[status]
          ? DETAILS_STATUS[status].description
          : "N/A";
    },
    checkPages() {
      return this.totalNumData > this.pagination;
    },
    updatedDevice(updatedGroup) {
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#create_device_cotainer");
      return instance.open(message, type);
    },

    editRow(row) {
      this.$refs.refAssingPermisses.setData({
        deviceId: row.code,
        company: row.company.code,
      });
      this.openModal();
    },
    openModal() {
      this.$refs.refAssingPermisses.openModal();
    },
    splitData() {
      if (!this.checkPages()) {
        this.tableData = this.originalData;
        return;
      }
      this.totalPages = Math.ceil(this.totalNumData / this.pagination);
      const offset = Math.round((this.page - 1) * this.pagination);
      const limit = Math.round(this.pagination * this.page);
      this.tableData = this.originalData.slice(offset, limit);
    },
    getListDevices() {
      this.isLoading = true;
        deviceEndpoint.getListDevices()
            .then(info => {
              this.isLoading = false;
              this.originalData = info;
              this.totalNumData = info.length;
              this.splitData();
            });
    },
  },
};
</script>

<style>
.sub-title {
  font-size: 1.6em;
  margin: 0;
  padding: 0;
}

.custom-container {
  margin-top: 20px;
}

.input-search {
  max-width: 300px;
}

.btn-add-device {
  margin-left: auto;
}

.text-right {
  display: flex;
  justify-content: flex-end;
}

.name-options-table {
  display: flex;
  width: 100%;
}

.name-options-table .options {
  margin-left: auto;
}

.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}

.name-options-table .options .btn span {
  font-size: 1.5em;
}

.name-options-table .options .btn:last-child {
  margin-right: 0;
}

.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}

.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}

.pagination-select {
  max-width: 120px;
}

.input-search-content {
  display: flex;
}
</style>
